import React, { lazy, Suspense } from "react";
import ReactGA from "react-ga4";
import "./App.css";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { Router, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";

import Loader from "./Utils/Loader/Loader";
import PageMiss from "./404/404";

const Home = lazy(() => import(/* webpackChunkName: "home" */ "./Home/Home"));

const About = lazy(() => import(/* webpackChunkName: "home" */ "./About-Us/About"));

const Products = lazy(() => import(/* webpackChunkName: "home" */ "./Products/Products"));

const BakerySolutions = lazy(() => import(/* webpackChunkName: "home" */ "./Products/BakerySolutions/BakerySolutions"));

const Chocolates = lazy(() => import(/* webpackChunkName: "home" */ "./Products/Chocolates/Chocolates"));

const CakeMixes = lazy(() => import(/* webpackChunkName: "home" */ "./Products/CakeMixes/CakeMixes"));

const FunctionalAdditives = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Products/FunctionalAdditives/FunctionalAdditives")
);

const FoodDecorations = lazy(() => import(/* webpackChunkName: "home" */ "./Products/FoodDecorations/FoodDecorations"));

const Applications = lazy(() => import(/* webpackChunkName: "home" */ "./Applications/Applications"));

const TechnicalSupport = lazy(() => import(/* webpackChunkName: "home" */ "./TechnicalSupport/TechnicalSupport"));

const Contact = lazy(() => import(/* webpackChunkName: "home" */ "./Contact/Contact"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#740d13",
    },
    secondary: {
      main: "#C99ACB",
    },
  },
  typography: {
    fontFamily: "Poppins",
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.customHistory = createBrowserHistory();
  }

  componentDidMount() {
    ReactGA.initialize("G-9C5ZX7KETZ");

    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    this.customHistory.listen((location) => {
      const path = location.pathname || window.location.pathname;
      ReactGA.send({ hitType: "pageview", page: path });
    });
  }

  render = () => {
    return (
      <ThemeProvider theme={theme}>
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <div className="loader-container">
                <Loader />
              </div>
            }>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/about" component={About} />
              <Route exact path="/products" component={Products} />
              <Route exact path="/products/bakery-solutions" component={BakerySolutions} />
              <Route exact path="/products/chocolates" component={Chocolates} />
              <Route exact path="/products/cake-mixes" component={CakeMixes} />
              <Route exact path="/products/functional-additives" component={FunctionalAdditives} />
              <Route exact path="/products/food-decorations" component={FoodDecorations} />

              <Route exact path="/applications" component={Applications} />
              <Route exact path="/technical-support" component={TechnicalSupport} />
              <Route exact path="/contact" component={Contact} />

              <Route component={PageMiss} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  };
}

export default App;
